/* eslint-disable react-hooks/exhaustive-deps */


import { useEffect, useState } from "react";
// import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useAccount } from "../component/context/AccountProvider";
import { useSearchParams } from "react-router-dom";
import { createSubscription } from "../service/ZohoPlanService";
import { getMyDetails } from "../service/myDeatils";

const useCreateZohoSubscription = () => {
  debugger
  // const { userDetails } = useAccount() || {};
  const [userDetails, setUserDetails] = useState({})
  const [searchParams] = useSearchParams();
  console.log(searchParams, "searchParams");
  useEffect(() => {
    async function loadUser() {
      try {
        const resp = await getMyDetails();
        setUserDetails(resp);
      } catch (err) {
        console.error("Failed to load user details:", err);
      }
    }
    loadUser();
  }, []);
  const removeSearchParams = (url) => {
    try {
      const urlObj = new URL(url);
      const params = new URLSearchParams(urlObj.search);
      params.delete("hostedpage_id");
      urlObj.search = params.toString();
      window.location.href = urlObj.toString();
      return urlObj.toString();
    } catch (error) {
      console.error("Invalid URL", error);
      return url;
    }
  };

  const updateSubscription = async (hostID) => {
    try {
      const payload = {
        hostedpage_id: hostID,
        user_id: userDetails?.id,
        organisation_id: userDetails?.organisation?.id || "",
      };

      const data = await createSubscription(payload);
      console.log(data, "createSubscription");
      if (data?.message) {
        toast.success("Subscription created successfully!");
        console.log(data, "createSubscription --2");
        setTimeout(() => {
          removeSearchParams(window.location.href);
          console.log(data, "createSubscription --3");
        }, 2000);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {

    const hostID = searchParams.get("hostedpage_id");
    console.log(searchParams, "searchParams");
    if (hostID && userDetails?.id) {
      updateSubscription(hostID);
    }
  }, [searchParams, userDetails]);
};

export default useCreateZohoSubscription;
